import React, { lazy, Suspense } from 'react';

const LazyBlockInfoUploadCv = lazy(() => import('./block-info-upload-cv'));

const BlockInfoUploadCv = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyBlockInfoUploadCv {...props} />
  </Suspense>
);

export default BlockInfoUploadCv;
